import cx from 'classnames'
import { OrganicResult } from './SerpResponseType'
import { Pressable } from '@react-aria/interactions'
import Styles from './SiteResult.module.scss'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'

interface Props {
  site: OrganicResult
  selectedWebsites: OrganicResult[]
  onSiteSelect: (site: OrganicResult, isSelected: boolean) => void
}

export const SiteResult = ({ site, selectedWebsites, onSiteSelect }: Props) => {
  const isSelected = selectedWebsites.includes(site)
  const isDisabled = !isSelected && selectedWebsites.length >= 3

  const handleChange = () => {
    onSiteSelect(site, !isSelected)
  }

  const openInNewTab = () => {
    window.open(site.link, '_blank')
  }

  return (
    <div className={Styles.resultContainer}>
      <Checkbox size="lg" isSelected={isSelected} onChange={handleChange} isDisabled={isDisabled} />
      <Pressable data-testid={`Result: ${site.title}`} onPress={handleChange} isDisabled={isDisabled}>
        <div className={cx(Styles.resultCard, { [Styles.selected]: isSelected })}>
          <div className={Styles.header}>
            <img alt="Favicon" className={Styles.favicon} src={site.favicon} />
            <Pressable onPress={openInNewTab}>
              <div className={Styles.pageInfo}>
                <span className={Styles.pageSource}>
                  {site.title} - {site.source}
                </span>
                <span className={Styles.displayLink}>{site.displayed_link}</span>
              </div>
            </Pressable>
          </div>
          <div className={Styles.snippet}>{site.snippet}</div>
        </div>
      </Pressable>
    </div>
  )
}
